// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pw-block[data-v-660ff808] {\n\tdisplay:inline-flex;\n\tflex-direction:row;\n\talign-items:center;\n\tgap:15px;\n\tpadding:5px;\n\tmin-width:220px;\n\tborder-radius:5px;\n\tbackground:var(--gris-clair);\n}\n.pw-content[data-v-660ff808] {\n}\n\n", ""]);
// Exports
module.exports = exports;
